/**
 * @generated SignedSource<<81f4105be4ccb193ba35d3605fa9d3e1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ScoroSettings_settings$data = {
  readonly scoro: {
    readonly apiKey: string | null;
    readonly apiUrl: string | null;
    readonly ownerId: number | null;
  } | null;
  readonly " $fragmentType": "ScoroSettings_settings";
};
export type ScoroSettings_settings$key = {
  readonly " $data"?: ScoroSettings_settings$data;
  readonly " $fragmentSpreads": FragmentRefs<"ScoroSettings_settings">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ScoroSettings_settings",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ScoroSettings",
      "kind": "LinkedField",
      "name": "scoro",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "apiKey",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "apiUrl",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "ownerId",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Settings",
  "abstractKey": null
};

(node as any).hash = "20c634d22d7596190b9c6588fcaa7cb4";

export default node;
